import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';
import { ShipmentList } from './shipment-list.model';

export class ShipmentsModel extends Model {

  @Expose() shipments: ShipmentList[] = [];
}
